module.exports = __webpack_public_path__ + "img/pause-yellow.90dd79d8.svg";